/**
 * Mobile device identity & registration (Day 9).
 *
 * Generates a stable per-device id (persisted in localStorage) and registers
 * the device with the backend on mobile use. The device id is sent on every
 * request via the `X-Device-Id` header (see lib/api.js) so an admin-blocked
 * device is denied and remotely logged out.
 */
import api from '../api';

export const DEVICE_ID_KEY = 'gc360_device_id';

export function getDeviceId() {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = (window.crypto?.randomUUID)
      ? window.crypto.randomUUID()
      : 'dev-' + Date.now().toString(36) + '-' + Math.random().toString(16).slice(2);
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}

export function getDeviceInfo() {
  const ua = navigator.userAgent || '';
  let platform = 'web';
  if (/android/i.test(ua)) platform = 'android';
  else if (/iphone|ipad|ipod/i.test(ua)) platform = 'ios';
  const standalone = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches)
    || window.navigator.standalone === true;
  return {
    platform,
    client_type: standalone ? 'native' : 'browser',
    app_version: '1.0.0',
  };
}

export async function registerDevice(pushToken) {
  try {
    const payload = { device_id: getDeviceId(), ...getDeviceInfo() };
    if (pushToken) payload.push_token = pushToken;
    const res = await api.post('/mobile/gateway/device/register', payload);
    return res.data?.data || null;
  } catch (e) {
    return null;
  }
}
